import DefaultFields, {
  IDefaultFields,
  IDefaultFieldsApiModel,
} from '@models/DefaultFields.model';
import { api } from '@services';

const getDefaultFields = async (): Promise<IDefaultFields[]> => {
  const { data: defaultFields } = await api.get<IDefaultFieldsApiModel[]>(
    '/defaultFields',
  );

  return DefaultFields.arrayFromApiModel(defaultFields);
};

export { getDefaultFields };
